import GlobalButtons from './GlobalButtons';
export default GlobalButtons;